import CommentSection from '@activities/account/AccountTerminationActivity/components/CommentSection';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import DisposeDescription from './DisposeDescription';
import TerminationFooter from './TerminationFooter';
import Header from '../Header';

function Termination() {
    const { t } = useTranslation('accountTermination');
    return (
        <Container>
            <Header title={t('header.title')}/>
            <Contents as='main'
                justify='space-between'
                fullWidth
                fullHeight>
                <Column fullWidth>
                    <CommentSection/>
                    <DisposeDescription/>
                </Column>
                <TerminationFooter/>
            </Contents>
            <IndexText color={colors.red} size='3xl' fontWeight='medium'>
                4
            </IndexText>
        </Container>
    );
}

const Container = styled(Column)`
    position: relative;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
`;

const Contents = styled(Column)`
    padding: 0 20px 12px;
`;

const IndexText = styled(Text)`
    position: absolute;
    bottom: 90px;
`;

export default Termination;
